var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _polygon, _path23, _polygon2, _path24, _path25, _polygon3, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuraHorizLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 598.73 274.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}.cls-17{fill:url(#linear-gradient-17);}.cls-18{fill:url(#linear-gradient-18);}.cls-19{fill:url(#linear-gradient-19);}.cls-20{fill:#231f20;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 120.35,
    y1: 31.81,
    x2: 150.14,
    y2: 31.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#872934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#a5252f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#bf222b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d31f28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e11d26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#ea1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec1c24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 160.04,
    y1: 36.75,
    x2: 188.62,
    y2: 36.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 184.39,
    y1: 51.64,
    x2: 223.01,
    y2: 51.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 202.2,
    y1: 75.08,
    x2: 249.58,
    y2: 75.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 212.93,
    y1: 106.36,
    x2: 265.35,
    y2: 106.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 215.42,
    y1: 145.76,
    x2: 268.78,
    y2: 145.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 209.38,
    y1: 183.28,
    x2: 259.95,
    y2: 183.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 195.49,
    y1: 210.66,
    x2: 239.54,
    y2: 210.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 175.25,
    y1: 230.86,
    x2: 209.41,
    y2: 230.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 143.66,
    y1: 241.67,
    x2: 172.91,
    y2: 241.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 103.99,
    y1: 242.06,
    x2: 133.55,
    y2: 242.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 67.19,
    y1: 232.16,
    x2: 100.2,
    y2: 232.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 36.15,
    y1: 212.84,
    x2: 79.46,
    y2: 212.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 14.57,
    y1: 186.09,
    x2: 64.92,
    y2: 186.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 4.74,
    y1: 149.5,
    x2: 58.12,
    y2: 149.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 7.38,
    y1: 110.09,
    x2: 59.82,
    y2: 110.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 21.99,
    y1: 77.62,
    x2: 69.83,
    y2: 77.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 47.49,
    y1: 53.41,
    x2: 87.06,
    y2: 53.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 81.2,
    y1: 37.6,
    x2: 109.65,
    y2: 37.6,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.76,58.56,120.35,17.83s.46-11.59,14.29-12.71c5.42-.44,13,1.53,15.5,11.78,0-.23-14.38,41.66-14.38,41.66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.41,62.54,160,19s4.21-10.84,17.65-7.4C183,13,189.5,17.28,188.52,27.78c.07-.22-27.11,34.76-27.11,34.76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M184.39,74.62,197.2,33s7.49-8.89,19.09-1.28c4.56,3,9.35,9.19,5,18.8.15-.18-36.91,24.09-36.91,24.09"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.2,93.5l25.62-35.21s10-6,18.47,5c3.34,4.29,5.86,11.71-1.37,19.41.2-.15-42.72,10.81-42.72,10.81"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M212.93,117.13l35.65-25s11.37-2.42,15.87,10.72c1.75,5.14,1.74,13-7.6,17.92.24-.07-43.92-3.64-43.92-3.64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M215.42,143l41.82-12.07s11.55,1.39,11.54,15.28c0,5.43-2.56,12.84-13,14.47.23,0-40.37-17.68-40.37-17.68"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M209.38,168.2l43.49,2.15s10.46,5.06,5.95,18.17c-1.77,5.16-6.59,11.34-17,9.52.23.08-32.45-29.84-32.45-29.84"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M195.49,190.13,236,206.25s8.25,8.2-.29,19.16c-3.32,4.29-9.89,8.56-19.14,3.46.19.17-21-38.74-21-38.74"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M175.25,206.36l33,28.38s5.16,10.41-6.47,18c-4.54,3-12.14,4.89-19.23-2.93.12.2-7.32-43.47-7.32-43.47"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M150.82,215.16l22.05,37.55s1.49,11.52-12,14.94c-5.27,1.33-13.07.69-17.24-9,0,.24,7.16-43.49,7.16-43.49"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M124.88,215.56l8.67,42.66s-2.32,11.39-16.16,10.27c-5.42-.45-12.6-3.6-13.4-14.12,0,.23,20.89-38.81,20.89-38.81"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M100.2,207.5l-5.64,43.19s-5.89,10-18.6,4.46c-5-2.18-10.77-7.48-8.09-17.69-.13.2,32.33-30,32.33-30"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M79.46,191.89l-19.34,39s-8.81,7.56-19-1.82c-4-3.67-7.74-10.55-1.91-19.35-.18.16,40.3-17.85,40.3-17.85"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M64.92,170.4,34,201s-10.8,4.29-17.42-7.9c-2.6-4.78-3.89-12.51,4.46-18.94-.21.1,43.92-3.8,43.92-3.8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M58.12,145.36,18.91,164.29S7.3,164.86,5,151.17c-.9-5.37.37-13.09,10.37-16.46-.22,0,42.78,10.65,42.78,10.65"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M59.82,119.45l-43.23,5.21s-11.16-3.23-8.91-16.94c.88-5.38,4.58-12.26,15.12-12.2-.22-.06,37,23.93,37,23.93"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M69.83,95.5,27.24,86.4s-9.51-6.68-2.93-18.9c2.58-4.79,8.3-10.13,18.28-6.65-.2-.12,27.24,34.65,27.24,34.65"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M87.06,76.1,49.73,53.67s-6.81-9.39,3.34-18.83c4-3.71,11.16-6.87,19.46-.35-.16-.18,14.53,41.61,14.53,41.61"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M109.65,63.34,81.61,30S78.2,18.9,90.89,13.28c5-2.21,12.78-2.88,18.51,6-.06-.23.25,44.08.25,44.08"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M357.77,128.17v36.12h-8.7c-2.78,0-4.28-1.4-4.53-4.19V146.17c-3.74,5.71-7.63,10.06-11.68,13a26,26,0,0,1-6.91,3.58,25.68,25.68,0,0,1-8.71,1.55,15.67,15.67,0,0,1-10-3.11,16.4,16.4,0,0,1-5-6.78,34.83,34.83,0,0,1-2.63-13.48q0-16.55,12.47-23.71a20.46,20.46,0,0,1,10.41-2.62,23.65,23.65,0,0,1,8.16,1.43,27.79,27.79,0,0,1,9.7,5.47q2.26,2,3.36,2c.39,0,.59-.24.59-.72,0-.08.05-1,.13-2.81s.11-3.42.11-4.94q0-18.47-8.39-21.09a22,22,0,0,0-6.6-1.07,16.56,16.56,0,0,0-5.27.83,32,32,0,0,0-8,4.53q-3.72,2.74-7.56,5.48c-2.79,2-4.51,2.78-5.15,2.39a.84.84,0,0,1-.25-.6c0-.39.57-1.26,1.68-2.62a47.85,47.85,0,0,1,8-7.15c1.67-1.19,3.45-2.35,5.35-3.46a30.53,30.53,0,0,1,17.29-4.53,31.16,31.16,0,0,1,5.72.7,18,18,0,0,1,11,7,24.43,24.43,0,0,1,4.64,12.22,188.58,188.58,0,0,1,.84,20.43m-13.23,7.75a7,7,0,0,0-.35-2.26,20.65,20.65,0,0,0-4.46-6.8,26.83,26.83,0,0,0-6.35-5.37q-5-3-9.37-2.37a10.08,10.08,0,0,0-5.35,2.91,13.89,13.89,0,0,0-3.68,5.18,31,31,0,0,0-1.77,13.84q1.07,13.69,10.91,14.9c6.49.77,12.35-3.18,17.56-11.93,1.91-3.17,2.86-5.88,2.86-8.1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M372.32,88.38h9.92c2.67,0,4.08,1.45,4.25,4.4v56.37q0,6.43,6,6.43a7.34,7.34,0,0,0,3.1-.72c2.55-1.1,5-3.46,7.39-7q7.14-10.86,10-19.2a66.21,66.21,0,0,0,2.75-11.43,106.53,106.53,0,0,0,.83-12.51c0-4.22.05-8.39.12-12.52.08-2.54.91-3.8,2.51-3.8h10.71v75.91h-10.6c-1.82,0-2.82-1.55-3-4.65v-33a59.46,59.46,0,0,1-2.14,6.91q-6.69,19.54-21.11,28.72a13.7,13.7,0,0,1-7.26,2,13.16,13.16,0,0,1-7.51-2.27,10.65,10.65,0,0,1-4.4-6.44,107.63,107.63,0,0,1-1.2-10.73c-.23-2.54-.34-5.57-.34-9V88.38Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M496.49,93.48v11.69a20.77,20.77,0,0,0-3.82-7c-2.06-2.46-4.29-3.7-6.68-3.7A8.56,8.56,0,0,0,480,97.19a85.69,85.69,0,0,0-10.37,12.5q-5.48,9.3-7.86,14.07-3.1,5.85-3.1,8.94v28.13a4,4,0,0,1-2.62,3.58H444.28V88.26h9.3q5.13.34,4.65,4.65v25.24c0,2.39.12,3.66.36,3.82s1.43-1.87,3.34-6.08q5.47-12.15,10.36-18.48c4.69-6.1,10-9.15,16-9.15,5.47,0,8.22,1.74,8.22,5.22"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "356.07 180.6 358.84 180.6 353.39 204.86 349.96 204.86 344.62 180.6 347.36 180.6 351.7 201 351.76 201 356.07 180.6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M379.89,180.14c7,0,7.38,8,7.38,12.48,0,3.2.22,12.49-7.38,12.49-7.41,0-7.37-9.08-7.37-12.49,0-10.05,3.34-12.48,7.37-12.48m4.88,12.48c0-2.21.33-10.38-4.88-10.38s-4.87,9-4.87,10.38c0,2.74-.14,10.38,4.87,10.38,2.5,0,4.88-1.68,4.88-10.38"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "411.92 180.6 414.7 180.6 408.56 194.49 408.56 204.63 406.06 204.63 406.06 194.49 399.91 180.6 402.69 180.6 407.32 191.48 411.92 180.6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M444.5,204.63h-2.7l-2.14-7.07h-7.31l-2.13,7.07h-2.7l8.48-26ZM433,195.45h6.1l-3.06-9.7Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M463.55,194.72v-2.1h8.18v12.49h-2.5v-2.35a6.46,6.46,0,0,1-5,2.35c-1.94,0-7.24-.34-7.24-12,0-9.51,2.89-13,7.57-13,4.08,0,6,2.87,6,6.61h-2.5c.19-2.2-.87-4.51-3.41-4.51-5,0-5.2,7-5.2,10.55,0,3.33.17,10.21,4.87,10.21,2.33,0,4.91-1.88,4.91-6.67v-1.61Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "499.12 182.71 489.15 182.71 489.15 191.24 496.32 191.24 496.32 193.35 489.15 193.35 489.15 202.53 499.36 202.53 499.36 204.63 486.65 204.63 486.65 180.6 499.12 180.6 499.12 182.71"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M525.28,184.94c-1.46-1.3-3.13-2.7-5.2-2.7a3.66,3.66,0,0,0-3.86,3.68c0,1.26.22,2.39,3.46,4.37l1.9,1.16c4.4,2.71,5.62,4,5.62,6.78,0,4.3-2.89,6.88-7.09,6.88-3.11,0-5.4-1.51-7.27-3.91l1.93-1.54a6.45,6.45,0,0,0,5.34,3.34,4.45,4.45,0,0,0,4.58-4.44c0-1.94-.15-2.6-4.38-5.15l-2.17-1.3c-2.36-1.38-4.43-3-4.43-6,0-3.76,2.86-5.94,6.47-5.94a10,10,0,0,1,6.61,3Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M555.61,129.11v36.1h-8.7c-2.79,0-4.29-1.38-4.52-4.17V147.1q-5.61,8.58-11.68,13a26.33,26.33,0,0,1-6.91,3.58,25.55,25.55,0,0,1-8.7,1.55,15.6,15.6,0,0,1-10-3.1,16.43,16.43,0,0,1-5-6.79,34.92,34.92,0,0,1-2.61-13.45q0-16.59,12.45-23.73a20.61,20.61,0,0,1,10.43-2.62,23.86,23.86,0,0,1,8.14,1.43,27.71,27.71,0,0,1,9.71,5.49q2.28,2,3.36,2c.39,0,.59-.24.59-.7,0-.1,0-1,.12-2.82s.13-3.41.13-4.93q0-18.48-8.4-21.09a21.09,21.09,0,0,0-6.59-1.08,16.76,16.76,0,0,0-5.27.83,32.22,32.22,0,0,0-8,4.54q-3.72,2.74-7.56,5.47-4.19,3-5.15,2.39a.81.81,0,0,1-.24-.6c0-.4.56-1.27,1.67-2.62a48.11,48.11,0,0,1,8-7.15c1.68-1.2,3.46-2.34,5.36-3.46a30.59,30.59,0,0,1,17.28-4.52,29.33,29.33,0,0,1,5.72.72,17.79,17.79,0,0,1,11,7,24.35,24.35,0,0,1,4.63,12.22,189,189,0,0,1,.84,20.45m-13.22,7.74a7.09,7.09,0,0,0-.37-2.26,20.76,20.76,0,0,0-4.44-6.8,26.66,26.66,0,0,0-6.36-5.35q-5-3-9.38-2.39A10,10,0,0,0,516.5,123a13.9,13.9,0,0,0-3.68,5.17A31.16,31.16,0,0,0,511.05,142q1.06,13.69,10.91,14.92T539.54,145c1.91-3.19,2.85-5.88,2.85-8.11"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuraHorizLogo);
export default __webpack_public_path__ + "static/media/aura-horiz-logo.228f16345d8181440f2fed600aac3d19.svg";
export { ForwardRef as ReactComponent };